export const projectNoteTypes = {
  'general': 'Algemeen',
  'calculation': 'Calculatie',
  'invoicing': 'Facturatie',
  'workorder': 'Opmerking op werkbon',
}

export type NoteType = keyof typeof projectNoteTypes;
export class ProjectNote {
  constructor(
    public readonly id: string,
    public readonly project_id: string,
    public readonly user_id: string,
    public readonly type: NoteType,
    public readonly note: string,
    public readonly createdAt: Date,
    public readonly updatedAt: Date
  ) {
  }

  static fromJson(json: any): ProjectNote {
    return new ProjectNote(
      json['id'],
      json['project_id'],
      json['user_id'],
      json['type'],
      json['note'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    );
  }
}